<template>
  <li class="relative border-b-2 border-b-slate-100 last:border-b-0">
    <div
      class="flex cursor-pointer items-center justify-between overflow-hidden text-ellipsis whitespace-nowrap"
      @click="open"
    >
      <!-- This slot will handle the title/header of the accordion and is the part you click on -->
      <slot name="accordion-trigger"></slot>

      <transition
        name="rotate"
        @enter="start"
        @after-enter="end"
        @before-leave="start"
        @after-leave="end"
      >
        <div
          class="flex cursor-pointer items-center justify-between overflow-hidden text-ellipsis whitespace-nowrap"
        >
          <slot name="accordion-icon">
            <OutlineChevronDownIcon
              v-show="!visible"
              class="animate-rotate h-6 w-6 text-gray-500"
            />
            <OutlineChevronUpIcon v-show="visible" class="animate-rotate h-6 w-6 text-gray-500" />
          </slot>
        </div>
      </transition>
    </div>

    <transition
      name="collapse"
      enter-active-class="will-change transition-[height,opacity] duration-100 ease-in-out overflow-hidden"
      leave-active-class="will-change transition-[height,opacity] duration-100 ease-in-out overflow-hidden"
      enter-class="!h-0 opacity-0"
      leave-to-class="!h-0 opacity-0"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div v-show="visible">
        <ul>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <slot name="accordion-content"></slot>
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'AccordionItem',
  inject: ['Accordion'],
  props: {
    defaultOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      index: null,
    }
  },

  computed: {
    visible() {
      return this.index == this.Accordion.active
    },
  },

  created() {
    this.index = this.Accordion.count++
    this.Accordion.active = this.defaultOpen ? this.index : null
  },

  methods: {
    open() {
      this.Accordion.active = this.visible ? null : this.index
    },

    start(el) {
      el.style.height = el.scrollHeight + 'px'
    },

    end(el) {
      el.style.height = ''
    },
  },
}
</script>
